// extracted by mini-css-extract-plugin
module.exports = {"PromptText":"PromptText_PromptText__2Bd0j","PromptText__griditem":"PromptText_PromptText__griditem__3qR99","OptionalHeader":"PromptText_OptionalHeader__2SxE3"};